import React from 'react';
import {
    Button, FormControl, Grid, Icon, IconButton, InputAdornment, InputLabel, makeStyles,
    OutlinedInput, TextField, Typography
} from '@material-ui/core';

import { UserContext } from '../UserContext';
import { validateEmail } from '../../../shared/operators';
import { UserModel } from '../../../Models/UserModel';

export interface ILoginProps {
    onClick: () => void,
    onBack: () => void,
    onPasswordRecovery: () => void,
}

const useStyles = makeStyles(() => ({
    container: {
        width: '430px'
    },
    title: {
        marginBottom: '36px',
        marginTop: '48px'
    },
    itens: {
        marginTop: '20px'
    },
    textLink: {
        margin: '4px',
        cursor: 'pointer'
    }
}));

export function LoginInput({ onClick, onBack, onPasswordRecovery }: ILoginProps) {
    const classes = useStyles();

    const userContext = React.useContext(UserContext);

    const [errorEmail, setErrorEmail] = React.useState<boolean>(false);
    const [showPassword, setShowPassword] = React.useState<boolean>(false);

    const validEmail = () => {
        setErrorEmail(!validateEmail(userContext.user.email ?? ''));
    };

    const handleChange = (prop: keyof UserModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        userContext.setUser({ ...userContext.user, [prop]: event.target.value });
    };

    const handleChangeBlock = (e: React.ClipboardEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    const getDisabledSubmit = () => {
        return errorEmail || !userContext.user.email || !userContext.user.password;
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="flex-start"
            className={classes.container}>
            <Typography variant='h3' className={classes.title} color="textPrimary">
                Entrar
            </Typography>
            <FormControl fullWidth>
                <TextField
                    id="user-metric"
                    label="Email"
                    variant="outlined"
                    className={classes.itens}
                    value={userContext.user.email}
                    onBlur={validEmail}
                    error={errorEmail}
                    helperText={errorEmail ? (userContext.user.email ? 'O email inserido não é válido.' : 'Campo obrigatório') : ''}
                    onChange={handleChange('email')} />
                <FormControl
                    className={classes.itens}
                    variant="outlined">
                    <InputLabel htmlFor="password">
                        Senha
                    </InputLabel>
                    <OutlinedInput
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        onCut={handleChangeBlock}
                        onCopy={handleChangeBlock}
                        onPaste={handleChangeBlock}
                        value={userContext.user.password}
                        onChange={handleChange('password')}
                        onKeyPress={(ev) => { (ev.key === 'Enter') && onClick(); }}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="pressione para exibir a senha"
                                    onClick={() => setShowPassword(!showPassword)}
                                    onMouseDown={handleMouseDownPassword}>
                                    {showPassword
                                        ? <Icon>visibility</Icon>
                                        : <Icon>visibility_off</Icon>}
                                </IconButton>
                            </InputAdornment>
                        }
                        labelWidth={50} />
                </FormControl>
                <Grid
                    container
                    direction="column"
                    justify="flex-end"
                    alignItems="flex-end">
                    <Typography variant='body1' color="primary" className={classes.textLink} onClick={onPasswordRecovery}>
                        Esqueci minha senha
                    </Typography>
                </Grid>
            </FormControl>
            <Button
                size="large"
                variant="contained"
                color="primary"
                fullWidth
                className={classes.itens}
                onClick={onClick}
                disabled={getDisabledSubmit()}>
                ACESSAR
            </Button>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center">
                <Typography variant='body1' color="primary" >
                    Seu primeiro acesso?
                </Typography>
                <Typography variant='body1' color="primary" className={classes.textLink} onClick={onBack}>
                    Clique aqui
                </Typography>
            </Grid>
        </Grid>
    );
}